// Load Styles
import "../sass/app.scss"

// Load Icons
// import fontawesome from '@fortawesome/fontawesome'
// import solid from '@fortawesome/fontawesome-free-solid'
// import regular from '@fortawesome/fontawesome-free-regular'
// import brands from '@fortawesome/fontawesome-free-brands'

// fontawesome.config = {
//     familyPrefix: 'fa',
//     autoAddCss: true,
//     autoReplaceSvg: false
// }

// fontawesome.library.add(solid, regular, brands)

// Load Scripts
import "jquery"
import "bootstrap"

// Load Custom JS
import "./vendor/custom.js"
